import React from "react";

const ChevronIcon = ({ isOpen = false }) => (
  <div className='lbv2__chevron-icon'>
    <i className={`fa-solid fa-chevron-${isOpen ? 'up' : 'down'}`} />
  </div>
);

export default ChevronIcon;
